/** EvolveRPG — English overrides for the auth feature. Fast-play, momentum-driven voice. */
export const authEvoEn = {
  // ── AuthShell ────────────────────────────────────────────────────────────
  'auth.shell.homeAriaLabel': 'EvolveRPG home',
  'auth.shell.logoAlt': 'EvolveRPG',

  // ── AccountVerifyPage ────────────────────────────────────────────────────
  'auth.verify.seoDescription': 'Verifying your EvolveRPG sign-in link.',
  'auth.verify.signedInAsSuffix': '. Taking you to your table…',
  'auth.verify.takingYouToSanctum': 'Taking you to your table…',

  // ── LoginPage ────────────────────────────────────────────────────────────
  'auth.login.seoTitle': 'Jump Back In',
  'auth.login.seoDescription': 'Sign in to EvolveRPG and get back to your table.',
  'auth.login.eyebrow': 'Welcome Back',
  'auth.login.title': 'Jump Back In',
  'auth.login.blurb': 'Enter your email and password to get back to the table.',
  'auth.login.noPactYet': 'New here?',
  'auth.login.forgeYourLegend': 'Create your character',
  'auth.login.emailPlaceholder': 'you@evolverpg.com',
  'auth.login.submitBusy': 'Loading…',
  'auth.login.submit': 'Play',

  // ── RegisterPage ─────────────────────────────────────────────────────────
  'auth.register.errorEmailRequired': 'An email is required to create your account.',
  'auth.register.errorMustBeAdult': 'You must be 13 or older to join EvolveRPG.',
  'auth.register.errorMustAcceptTerms': 'You must accept the terms to continue.',
  'auth.register.errorIncomplete': 'A few fields still need your attention. See below.',
  'auth.register.seoTitle': 'Start Your Session',
  'auth.register.seoDescription': 'Create an EvolveRPG account, build a character, and get to the table fast.',
  'auth.register.eyebrow': 'Fast-Play Tabletop RPG',
  'auth.register.title': 'Start Your Session',
  'auth.register.blurb': 'Session zero starts now — let’s get you set up.',
  'auth.register.alreadyBound': 'Already have an account?',
  'auth.register.displayNamePlaceholder': 'Speedster42',
  'auth.register.emailPlaceholder': 'you@evolverpg.com',
  'auth.register.termsOfThePact': 'Terms of Service',
  'auth.register.submitBusy': 'Creating your account…',
  'auth.register.submit': 'Let’s Go',

  // ── ResetPasswordPage ────────────────────────────────────────────────────
  'auth.reset.errorInvalidEmail': 'Enter the email tied to your account.',
  'auth.reset.blurb': 'Enter your email and we’ll send a one-time link — click it to set a new password.',
  'auth.reset.successMessage':
    'If an account exists for {email}, a one-time link has been sent. Open it to sign in and set your new password — check your email, and your spam folder.',
  'auth.reset.emailPlaceholder': 'you@evolverpg.com',

  // ── SetPasswordPage ──────────────────────────────────────────────────────
  'auth.setPassword.seoDescription': 'Choose a new password for your EvolveRPG account.',
  'auth.setPassword.eyebrow': 'Set Your Password',
  'auth.setPassword.successMessage': 'Your password is set. Taking you to your table…',
}
